import React, { Component } from 'react';
import { Button, FormGroup, ControlLabel, FormControl, Badge, Checkbox } from 'react-bootstrap';
import { observer } from 'mobx-react';
import { FieldGroup } from './FieldGroup';
import { Validator } from './Validator';
import { validateRuleMap } from '../utils/ValidatorRulesUtils';
import { AlertGenerator } from './AlertGenerator';
import { CreateModal } from '../containers/CreateModal';

@observer
class AggregatorConfigFields extends Component {
  displayName = AggregatorConfigFields.name;

  constructor(props) {
    super(props);
    const initialState = props.initialState || {};
    this.state = { ...this.state, ...initialState };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.initialState === this.props.initialState)
      return;

    const initialState = this.props.initialState || {};
    this.setState({ ...this.state, ...initialState });
    const { configUpdated } = this.props.configurationStore;

    if((prevProps.configUpdated !== configUpdated) && configUpdated)
      this.props.configurationStore.setAlert('Update completed successfully!', 'success');
  }

  componentWillUnmount() {
    if (this.props.configurationStore !== undefined)
      this.props.configurationStore.resetConfigUpdated();
  }

  componentDidMount() {
    this.props.configurationStore.hideAlert();
  }

  state = {
    friendlyName: '',
    description: '',
    adqRefId: '',
    separator: '',
    channelId: 1,
    typeId: 1,
    tempTypeId: 0,
    isCopy: false,
    showModal: false,
    selectedConfigItem: false,
    version: '1.0',
    hidden: false,
    customTemplate: false,
    plainTextOnly: false,
    ipPoolName: 'CirculationProduction',
    sendgridSubscriptionTracking: false,
    ignoreSendingTime: false
  };

  updateField(name, event) {
    this.setState({
      [name]: event.target.value
    });
  }

  updateCheckbox(name, event) {
    this.setState({
      [name]: event.target.checked
    });
  }

  changeNotificationTypeId = (event) => {
    const { config } = this.props.configurationStore;
    if (config !== void 0 && config.configItems.length > 0) {
      this.setState({ showModal: true, tempTypeId: event.target.value });
    } 
    else {
      this.updateField('typeId', event);
    }
  }

  hideNotificationModal = () => {
    this.setState({ showModal: false })
  }  

  updateNotificationTypeId = () => {
    this.setState({ typeId: this.state.tempTypeId, showModal: false }, () => { 
        this.props.setCurrentTypeId && this.props.setCurrentTypeId(this.state.tempTypeId) 
      }
    );
  }

  copyConfigLoadTarget = (event) => {
    const { currentCustomerId } = this.props.configurationStore;

    this.props.configurationStore.setCurrentConfigId(parseInt(currentCustomerId, 10), parseInt(event.target.value, 10));
    const { config } = this.props.configurationStore;
    this.setState({
      friendlyName: '',
      description: config.description,
      adqRefId: '',
      separator: config.separator,
      channelId: config.channelId,
      typeId: config.typeId,
      isCopy: true,
      selectedConfigItem: true
    })
  }

  submit = (event) => {
    event.preventDefault();
    
    const { configurationStore } = this.props;
    const { configs } = configurationStore.customer;
    const validState = validateRuleMap(this.props.rules, this.state);

    if (!validState) {
      configurationStore.setAlert('Some fields are invalid!', 'danger');
      return;
    }

    const configIdExists = configs.find(config => config.adqRefId === parseInt(this.state.adqRefId));
    const configNameExists = configs.find(config => config.friendlyName === parseInt(this.state.friendlyName));

    if(!configurationStore.currentConfigId && (configIdExists || configNameExists)) {
      const msg = configIdExists ? 'Processlink File Master Id already exists!' : 'Friendly Name already exists!';
      configurationStore.setAlert(msg, 'danger');
      return;
    }

    const submitSuccess = () => {
      this.props.closeModal && this.props.closeModal();
    }

    let configFields = Object.assign({}, this.state);
    delete configFields.configItems; //configItems not needed in update since they are not kept up to date
    this.props.onSubmit(configFields, submitSuccess);
  };

  render() {
    const { buttonText, notificationChannels, notificationTypes, rules, configurationStore, isCopyFromExisting } = this.props;
    const { alertMessage, hideAlert, customer, config } = configurationStore;
    return (
      <form onSubmit={this.submit}>
        <AlertGenerator alertMessage={alertMessage} hideAlert={hideAlert}></AlertGenerator>
        <CreateModal title='Heads up!' handleClose={this.hideNotificationModal} show={this.state.showModal}>
          <div>If you change this value, you will lose any config items associated with this notification type. Proceed?</div>
          <div className='text-right'>
            <Button bsStyle='default' className='mr-1' onClick={this.hideNotificationModal}>Cancel</Button>
            <Button bsStyle='primary' onClick={this.updateNotificationTypeId}>Proceed</Button>
          </div>
        </CreateModal>
        {isCopyFromExisting && 
          <div>
            <FormGroup controlId="configCopy">
              <ControlLabel>Choose from existing config</ControlLabel>
              <FormControl componentClass="select"
                value={this.state.configCopyTarget}
                onChange={this.copyConfigLoadTarget}
              >
                <option value="" disabled={this.state.selectedConfigItem}>--Select--</option>
                {customer.configs.map(item => <option value={item.id} key={item.id}>{item.friendlyName}</option>)}
              </FormControl>
            </FormGroup>
            {
              this.state.selectedConfigItem ? 
                config.configItems.map(item => {
                  if(item.propertyName.trim().length > 0)
                    return <span className='mr-2' key={item.propertyName}><Badge>{item.propertyName}</Badge></span>;
                })
              : null
            }
            <hr></hr>
          </div>}
        <Validator rules={rules.friendlyName}
          fieldName='friendlyName' value={this.state.friendlyName} render={({ isValid, message }) => (
            <FieldGroup
              id='configFriendlyNameInput'
              type='text'
              label='Friendly Name (name shown to editors, ex: Library Overdue 25 days)'
              onChange={this.updateField.bind(this, 'friendlyName')}
              value={this.state.friendlyName}
              isValid={isValid}
              message={message} 
              required
            />
          )}
        />
        <Validator rules={rules.description}
          fieldName='description' value={this.state.description} render={({ isValid, message }) => (
            <FieldGroup
              id='configDescriptionInput'
              type='text'
              label='Description (ex: Library Overdue)'
              onChange={this.updateField.bind(this, 'description')}
              value={this.state.description}
              isValid={isValid}
              message={message} 
              required
            />
          )}
        />
        <Validator rules={rules.adqRefId}
          fieldName='adqRefId' value={this.state.adqRefId} render={({ isValid, message }) => (
            <FieldGroup
              id='configAdqInput'
              type='text'
              label='Processlink File Master Id'
              onChange={this.updateField.bind(this, 'adqRefId')}
              value={this.state.adqRefId}
              isValid={isValid}
              message={message} 
              required
            />
          )}
        />
        <Validator rules={rules.separator}
          fieldName='separator' value={this.state.separator} render={({ isValid, message }) => (
            <FieldGroup
              id='configSeparatorInput'
              type='text'
              label='File Separator Character'
              onChange={this.updateField.bind(this, 'separator')}
              value={this.state.separator}
              isValid={isValid}
              message={message} 
              required
            />
          )}
        />
        <FormGroup controlId="notificationTypeSelect">
          <ControlLabel>Notification Type</ControlLabel>
          <FormControl componentClass="select"
              value={this.state.typeId}
              onChange={this.changeNotificationTypeId}
          >
            {notificationTypes.map(type => <option value={type.id} key={type.id}>{type.name}</option>)}
          </FormControl>
        </FormGroup>
        <FormGroup controlId="notificationChannelSelect">
          <ControlLabel>Notification Channel</ControlLabel>
          <FormControl componentClass="select"
              value={this.state.channelId}
              onChange={this.updateField.bind(this, 'channelId')}
          >
            {notificationChannels.map(channel => <option value={channel.id} key={channel.id}>{channel.channel}</option>)}
          </FormControl>
        </FormGroup>
        <FormGroup controlId="ipPoolNameSelect">
          <ControlLabel>IP Pool Name</ControlLabel>
          <FormControl componentClass="select"
            value={this.state.ipPoolName}
            onChange={this.updateField.bind(this, 'ipPoolName')}
          >
            <option value="CirculationProduction">Circulation</option>
            <option value="MarketingProduction">Marketing</option>
            <option value="UniqueSpecial">Special</option>
          </FormControl>
        </FormGroup>
        <FormGroup>
          <Checkbox checked={this.state.plainTextOnly} onChange={this.updateCheckbox.bind(this, 'plainTextOnly')} inline>Plain Text Only?</Checkbox>
          <Checkbox checked={this.state.sendgridSubscriptionTracking} onChange={this.updateCheckbox.bind(this, 'sendgridSubscriptionTracking')} inline>Include List Unsubscribe?</Checkbox>
          <Checkbox checked={this.state.customTemplate} onChange={this.updateCheckbox.bind(this, 'customTemplate')} inline>Has Custom Template?</Checkbox>
          <Checkbox checked={this.state.hidden} onChange={this.updateCheckbox.bind(this, 'hidden')} inline>Hidden Config? (Will remove from UI)</Checkbox>        
          <Checkbox checked={this.state.ignoreSendingTime} onChange={this.updateCheckbox.bind(this, 'ignoreSendingTime')} inline>Ignore Sending Time</Checkbox>
        </FormGroup>
        <Button bsStyle='primary' type="submit">{buttonText}</Button>
      </form>
    );
  }
}

export { AggregatorConfigFields };
